export default {
  product: {
    spu: '商品档案',
    all: '全部',
    offSale: '可售商品',
    onSale: '停售商品',
    productName: '商品名称',
    mnemonicCode: '助记码',
    sort: '显示序号',
    cateBaseIds: '后台分类',
    cateShowIds: '前台分类',
    saleTax: '销售税率',
    isShowDetail: '是否展示详情',
    isDiscount: '允许购买打折',
    isOnlyPrepaid: '是否仅预存款购买',
    isMemberOnly: '是否仅会员购买',
    isAuth: '是否需授权',
    isExchange: '是否允许兑换',
    statTagId: '统计标签',
    discountDesc: '优惠描述',
    skuName: '商品内容',
    productType: '商品品类',
    productSubType: '商品类型',
    status: '是否上架',
    isSale: '售卖状态',
    updateTime: '最后修改时间',
    productCode: '商品编码',
    productId: '总部SPUID',
    skuId: '总部SKUID',
    hqSpuId: '总部SPUID',
    hqSkuId: '总部SKUID',
    shopSpuId: '门店SPUID',
    shopSkuId: '门店SKUID',
    copy: '复制',
    copySuccess: '复制成功！',
    copyFail: '复制失败，请手动复制',
    productTip: '便于自然源收银使用助记码查找商品',
    Create: '创建商品',

    setStore: '当前涉及门店',
    SynStore: '已同步门店',
    PutStore: '已上架门店',
    Rules: '系统将按以下规则处理',
    del_1: '已同步门店:移除该商品的门店销售关系;',
    del_2: '未同步门店:终止后续同步，门店无法再获取或启用该商品;',
    del_3: '未上下架的门店:无需处理上下架状态。',
    del_4: '删除后不可恢复，请谨慎操作。',
    del_5: '该商品当前为',
    del_6: '状态，删除后将从总部商品库中移除，并不再支持门店同步、上架或销售',
    del_7: '确认删除该商品',

    sale_1: '启售后，支持门店上架销售。',
    sale_2: '启售不会改变门店的上下架状态。已上架门店在启售后可恢复销售，已下架门店仍保持下架。',
    sale_3: '是否确认启售?',
    sale_4: '停售后，该商品将不再允许门店销售，但不会删除商品数据。',
    sale_5: '停售不会改变门店的上下架状态。已上架门店将因总部停售限制而不可销售，已下架门店仍保持下架。',
    sale_6: '是否确认停售?',
    sale_7: '确认启售该商品?',
    sale_8: '确认停售该商品?',
    COUNT_TICKETTip: '适用固定次数项目，扫码核销扣次，用完即止',
    TIME_TICKETTip: '适用高频不限次游玩，有效期内可无限使用',

    ticketConfig: {
      playCount: '畅玩次数',
      useCount: '可用次数',
      dayUseCount: '每天可用次数',
      effectType: '生效方式',
      buyAfterDays: '购买',
      buyAfterDaysTip: '天后生效',
      validTime: '票有效期',
      timeSlotLimit: '可用时段',
      companionCount: '陪同人数',
      bindFriendCount: '可绑定亲友数',
      isFaceIdentify: '人脸识别验证',
      validEndTime: '有效期结束时间',
      validStartTime: '有效期开始时间',
      onVlidDate: '指定日期',
    },
    skuList: {
      salePrice: '销售价格',
      originPrice: '商品划线价',
      stock: '库存',
      stockSet: '库存',
    },
  },
  // 商品分类
  productClass: {
    changeCategory: '更改分类',
    sourceCategoryTip: '来源分类：{name}，共 {count} 个商品。请筛选并勾选要更改分类的商品。',
    changeCategorySelectedTip: '已选择 {count} 个商品从“{name}”分类移出，请选择目标分类。',
    targetCategory: '更改到后台分类',
    targetCategoryRequired: '请选择来源分类以外的末级后台分类作为目标',
    changeCategorySuccess: '商品分类更改成功',
    Association: '关联商品',
    associatedProductCount: '关联商品数',
    associationDialogTitle: '为“{name}”关联商品',
    associatedDialogTitle: '“{name}”的关联商品',
    selectedProductCount: '已选择 {count} 个商品',
    selectAtLeastOneProduct: '请至少选择一个未关联商品',
    batchAssociateConfirm: '确认将已选择的 {count} 个商品关联到当前分类吗？',
    associationSuccess: '商品关联成功',
    unbind: '解绑',
    batchUnbind: '批量解绑',
    unbindConfirm: '确认解除“{productName}”与当前分类的关联吗？',
    batchUnbindConfirm: '确认解除已选择的 {count} 个商品与当前分类的关联吗？',
    unbindSuccess: '商品解绑成功',
    unbindAction: '解除关联',
    unbindResultTitle: '解除关联结果',
    unbindResultCategory: '分类名称：{name}',
    unbindResultSuccess: '成功解除关联 {count} 个商品：{names}',
    unbindResultFailed: '{count} 个商品解除关联失败',
    unbindResultFailureTip: '以下商品未能解除关联，请查看商品详情。',
    unbindResultEmpty: '未返回商品解除关联结果，请刷新分类查看关联情况。',
    unbindResultEditProduct: '编辑商品',
    unbindResultAcknowledge: '我知道了',
    unbindSelectTip: '请至少选择一个要解除关联的商品',
    selectedCategoryTip: '选定分类：{name}，已关联 {count} 个商品',
    selectedCountWithMax: '已选择 {count} 个商品 /最多可选择 {max} 个商品',
    maxSelectTip: '最多可选择 {max} 个商品',
    cancelSelectionConfirm: '当前商品选择尚未保存，取消后将丢失本次修改，是否继续取消？',
    continueCancel: '继续取消',
    returnSelect: '返回选择',
    mnemonicCode: '助记码',
    productName: '商品名称',
    productCode: '商品编码',
    productContent: '商品内容',
    productType: '商品类型',
    backendCategory: '后台分类',
    frontendCategory: '前台分类',
    saleStatus: '售卖状态',
    availableForSale: '可售',
    unavailableForSale: '停售',
    alreadyAssociated: '已关联',
    associationStatus: '关联状态',
    addCalss: '添加分类',
    addChrenCalss: '添加子分类',
    FrontClass: '前台分类',
    fromClass: '后台分类',
    FrontClassTip: '原商品分类，商品前台展示分类，用于小程序端、自然源POS端等展示',
    addFromClass: '添加后台分类',
    editFromClass: '编辑后台分类',
    className: '分类名称',
    classCode: '分类编码',
    delfromClass: '是否删除该后台标签！',

    Information: '基础信息',
    Description: '分类描述',
    marks: '分类备注',
    Label: '分类标签',
    Logo: '分类标识',
    Icon: '图标',
    banner: '分类banner',
    sort: '排序',
    classSet: '分类设置',
    sortTip: '同一商品在不同分类下可独立维护排序值，开启【同一商品不同分类下排序一致】配置',
    limitTop: '限时置顶',
    topDate: '置顶日期',
    showChannel: '展示渠道',
    isOnlyBack: '是否仅在后台展示',
    markTip: '用于外部对接的分类标识码',
    delFrontClass: '是否删除该前台标签！',
    iconTip: '备注：建议图标尺寸：180px * 180px',
    bannerTip: '>备注：建议图标尺寸：530px * 150px',
    addtime: '添加时间段',
    addtimeTip: '最多添加 3 个',

    MP: '小程序',
    CASHIER: '收银台',
    POS: 'pos机',
    DEVICE: '自助设备',

    look: '查看',
  },
  // 商品属性
  attribute: {
    specificationManage: '规格管理',
    labelManage: '标签管理',
    cornerManage: '角标管理',
    specificationTip: '商品规格库，用户可选择商品的规格，如：大杯、小杯等，规格影响商品价格',
    labelTip: ' 描述标签展示在小程序端的商品名称下方、分类名称上方',
    labelTim: '描述标签展示在小程序端的商品名称下方、分类名称上方',
    cornerTip: '商品角标展示在小程序点单页-商品列表的商品图片中，用于新品、套餐等特殊标记展示',
    editaddLabel: '编辑标签',
    addSpecification: '新增规格',
    editSpecification: '编辑规格',
    specificationName: '规格名称',
    specificationNum: '规格值',
    specificationCode: '规格值编码',
    specificationPic: '规格图片',
    specificationMarks: '规格描述',
    picStatus: '是否展示规格图片',
    labelDescription: '描述标签',
    labelStatistics: '统计标签',
    labelDelTip: '是否删除该商品标签!',
    LabelGroupDelTip: '是否删除该商品标签组!',
    specificationDelTip: '是否删除该商品规格!',
    specValueDelTip: '是否删除改规格值！',

    pushSpecValue: '新增规格值',
    editSpecValue: '编辑规格值',

    addLabelGroup: '新增标签分组',
    editLabelGroup: '编辑标签分组',
    LabelGroupName: '标签分组名称',

    addLabel: '新增标签',
    editLabel: '编辑标签',
    tagGrouping: '标签分组',
    label: '标签',
    labelClass: '标签样式',
    labelName: '标签名称',
    bgColor: '背景颜色',
    fontColor: '字体颜色',
    effect: '效果',

    text: '文字',
    pic: '图片',

    addCorner: '新增角标',
    editCorner: '编辑角标',
    cornerName: '角标名称',
    corneDelTip: '是否删除该商品角标!',
  },
  // 商品同步
  shopProductSynch: {
    sPut: '选择商品',
    shopset: '选择门店 & 设置',
    Completed: '完成',
    shopProductSynchRole: '商品同步规则',
    shopSput: '合并到门店商品',
    Same: '相同商品',
    shopProductSynch: '商品同步',
    SynProductsShop: '同步商品至门店',
    ResultPreview: '结果预览',
    SynProducts: '同步商品',
    shopCount: '同步门店',
    totalCount: '应处理',
    successCount: '成功',
    failCount: '失败',
    skipCount: '跳过',
    SynProductsInfo: '任务信息',
    taskNo: '任务编号',
    taskContent: '同步内容',
    syncType: '同步方式',
    execMode: '执行方式',
    createByName: '创建人',
    taskStatus: '执行状态',
    createTime: '创建时间：',
    scheduledTime: '计划执行时间',
    startedAt: '开始时间',
    finishedAt: '完成时间',
    empty1: '创建成功！',
    handleType: '处理方式',
    errorMessage: '失败/跳过原因',
    updateTime: '处理时间',
    pucCount: '个商品',
    shCount: '个门店',
  },
  // 门店商品
  shopProduct: {
    deltitle: '确认删除该商品?',
    deltip: '删除后将无法显示该商品，但您可随时从总部重新下发该商品，确认删除吗?',
    shelf: '上架',
    shelfTitle: '确认上架该商品?',
    shelfTip: '上架后，顾客即可在前台看到并购买此商品。',
    shelves: '下架',
    shelvesTitle: '确认下架该商品?',
    shelvesTip: '商品下架后将不在前台展示，您可随时在列表中重新上架，确认下架吗?',

    changeType: '库存变更类型',
    changeCount: '变更数量',
    addInventory: '增加库存',
    delInventory: '减少库存',
    isAutoRestock: '次日补足库存',
    restockCount: '库存补至',
    isTurnOn: '开启',
    Count: '当前剩余库存',
    salePrice: '商品价格',
    channels: '售卖渠道',
    channelsTip: '该商品没有售卖渠道，请联系总部下发！',
  },
  productBtn: {
    creatingCopy: '复制参数继续创建',
    productSave: '保存商品',
    isSave: '仅保存商品档案',
    creatingSave: '保存并继续创建',
    AdvancedCreation: '高级创建',
    QuickCreate: '快捷创建',
    detalis: '同步详情',
    returnList: '返回同步记录',
    ProductSynch: '继续同步',
    SubmitSynch: '提交并同步',
  },
  productTabs: {
    cardInfo: '基本信息',
    cardUseSet: '使用设置',
    cardSales: '销售信息',
    cardLaunch: '上架设置',
    cardExchange: '兑换设置',
    cardOperate: '经营信息',
    carGraphic: '图文详情',
    spuSynch: '同步记录',
    spuSynchSet: '商品工具',
  },
  productStock: {
    productList: '商品列表',
    inventoryAdjustmentRecord: '库存调整记录',
    stockMovementRecord: '出入库记录',
    productSummary: '商品汇总',
    shopDetail: '门店明细',
    viewMode: '查看方式',
    productName: '商品名称',
    productContent: '商品内容',
    hqSkuId: '总部 SKU ID',
    specificationCode: '门店 SKU ID',
    shopName: '门店名称',
    productType: '商品类型',
    shopCount: '门店数量',
    stockDistribution: '库存状态分布',
    currentStock: '当前库存',
    dailyRestock: '每日固定数量',
    dailyRestockValue: '每日 {count}',
    stockStatus: '库存状态',
    detail: '详情',
    stockDetail: '库存详情',
    storeStock: '门店库存',
    adjustStock: '调整库存',
    stockAdjustment: '库存调整',
    adjustmentMethod: '调整方式',
    increaseStock: '增加库存',
    decreaseStock: '减少库存',
    adjustmentQuantity: '调整数量',
    batchIncreaseStock: '批量增加库存',
    increaseQuantity: '增加数量',
    selectedProducts: '已选商品 {count} 个',
    batchIncreaseSuccess: '批量增加库存成功',
    confirmAdjustment: '确认调整',
    confirmAdjustmentTitle: '确认库存调整',
    stockSettings: '库存设置',
    autoRestock: '每日固定数量',
    autoRestockTip: '开启后，每日自动将库存补至设定数量',
    restockQuantity: '每日补足数量',
    stockThreshold: '低库存阈值',
    stockThresholdPlaceholder: '请输入低库存阈值',
    saveSettings: '保存设置',
    discardChangesTitle: '放弃修改？',
    discardChangesMessage: '当前修改尚未保存，关闭后将不会保留。',
    continueEditing: '继续编辑',
    discardChanges: '放弃修改',
    insufficientStock: '减少数量不能大于当前库存',
    all: '全部',
    soldOut: '售罄',
    lowStock: '低库存',
    normal: '正常',
    countTicket: '计次票',
    timeTicket: '年月票',
    enabled: '开启',
    disabled: '关闭',
    changeType: '变更类型',
    changeCount: '变更数量',
    beforeStock: '变更前库存',
    afterStock: '变更后库存',
    sourceNo: '关联单据编号',
    remark: '备注',
    operator: '操作人',
    operationSource: '操作来源',
    clientSystem: '系统',
    clientAdmin: '管理后台',
    clientApp: 'APP',
    clientCashier: '收银台',
    clientMiniProgram: '小程序',
    systemOperator: '系统',
    projectDeductionNo: '项目扣费流水号',
    afterSalesNo: '售后单号',
    salesOrderNo: '销售订单号',
    operationTime: '操作时间',
    dailyStockReplenishment: '每日补充库存',
    manualDecrease: '手动减少',
    manualIncrease: '手动增加',
    salesDecrease: '销售减少',
    refundReplenishment: '退款回补',
  },
  productType: {
    Mandatory: '强制',
    Recommend: '推荐',
    BUY_AFTER: '购买后生效',
    FIRST_USE: '首次使用生效',
    DAYS_AFTER: '购后X天生效',
    CUSTOM: '自定义时间',

    COMMON: '实物商品',
    COMBO: '套餐商品',
    TICKET: '票务商品',
    GAME_COIN: '游戏币商品',

    COUNT_TICKET: '计次票',
    TIME_TICKET: '年月票',

    // 同步
    MERGE: '合并',
    ADD: '仅新增',
    UPDATE: '仅更新',
    IMMEDIATE: '立即执行',
    SCHEDULED: '定时执行',
    MANUAL: '手动执行',
    PENDING: '待执行',
    EXECUTING: '执行中',
    SUCCESS: '全部成功',
    PARTIAL_SUCCESS: '部分成功',
    FAILED: '全部失败',
    CANCELLED: '已取消',

    isADD: '新增',
    isUPDATE: '更新',
    SKIP: '跳过',
  },
};
